var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.725 25.8476C18.205 25.6576 17.945 25.0776 18.135 24.5576L19.505 20.7276C19.695 20.2076 20.275 19.9476 20.795 20.1376C21.315 20.3276 21.575 20.9076 21.385 21.4276L20.015 25.2576C19.825 25.7776 19.245 26.0376 18.725 25.8476Z",
    fill: "#66AFEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4549 27.7076C10.9349 27.5276 10.6549 26.9576 10.8449 26.4376L12.2849 22.4176C12.4649 21.8976 13.0349 21.6176 13.5549 21.8076C14.0749 21.9876 14.3549 22.5576 14.1649 23.0776L12.7249 27.0976C12.5449 27.6076 11.9749 27.8876 11.4549 27.7076Z",
    fill: "#66AFEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.945 11.8677C24.585 11.8677 24.235 11.9377 23.905 12.0277C23.905 11.9777 23.915 11.9177 23.915 11.8677C23.915 7.65766 20.495 4.23766 16.285 4.23766C12.725 4.23766 9.74498 6.67766 8.90498 9.96766C8.62498 9.91766 8.33498 9.88766 8.03498 9.88766C5.37498 9.88766 3.22498 12.0377 3.22498 14.6977C3.22498 17.0877 4.98498 19.1977 7.26498 19.5777H7.30498H16.325H16.335H16.345H24.535C24.725 19.5777 24.865 19.5777 24.965 19.5777C27.085 19.5777 28.775 17.8177 28.775 15.7077C28.775 13.5977 27.065 11.8677 24.945 11.8677Z",
    fill: "#9EC5FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.52b36f026ce02e4f791fde7a8a92aa90.svg";
export { ForwardRef as ReactComponent };